import angularHost from '../../../../../embedded-web2/src/embedding-framework/angular-adapters/angularHost';

export default {
  removeAlcoholFromCart(): Promise<void> {
    return angularHost.menuService().removeAlcohol();
  }
};
